import dayjs from 'dayjs';

export const getTodayDate = () => dayjs();
export const getTomorrowDate = () => getTodayDate().add(1, 'day');
export const getAYearAfterTodayDate = () => getTomorrowDate().add(1, 'year');
// Numeric CrmTaskStatus for `Expired` (Просрочена) — a task past its deadline
// that is NOT completed. `4` is `CompletedExpiration` (Выполнена с просрочкой),
// which is a different, already-finished state.
export const EXPIRED_STATUS_INDEX = 3;
export const TASK_REGISTRY_STORAGE_KEY = 'TaskRegistryFilters.v1';
